export default "__VITE_ASSET__BhDu3cdL__"